/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';



import {
	Card, CardImg, CardText, CardBody,
	CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label, ButtonGroup
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';

import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import Fuse from "fuse.js";
import ReactDOM from 'react-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';


class AddJumpers extends Component {

	constructor(props) {

		super(props);
		this.toggleModal = this.toggleModal.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);
		this.updateGear = this.updateGear.bind(this);
		this.MultiValueLabel = this.MultiValueLabel.bind(this);

		this.state = {
			isModalOpen: false,
			jumpType: null,
			jumperOptions: [],
			ErrorMessage: '',
			isValid: true,
			editMode: false,
			jumpers: [],
			jumpId: props.jumpId,
			loadNum: props.loadNum,
			placement: 'bottom',

		};

		this.timerId = undefined;
		this.valRef = null;
		this.inputValue = "";

		this.studentgearIds = [];
		this.sportgearIds = [];
		this.gearIds = [];

		this.fuse = undefined;
	}


	componentDidMount = () => {
		var jumperOptions = jumpersStore.getJumperOptions();
		if(this.props.activeJumperIdsOnLoad){
			jumperOptions = jumperOptions.filter(
				option =>
					this.props.activeJumperIdsOnLoad.findIndex(
						id => option.value._id === id
					) === -1
			);
		}
		this.setState({jumperOptions: jumperOptions});
		this.setFuse(jumperOptions);
	}
	componentDidUpdate = () => {
		//console.og('in component did update editable jumper');
		//console.og("edit mode: " + this.state.editMode);
		if (this.valRef !== null) {
			this.valRef.focus();

			//alert("window height " + window.innerHeight + " " + JSON.stringify(ReactDOM.findDOMNode(this).getBoundingClientRect()));
		}
		var jumperOptions = jumpersStore.getJumperOptions();
		if(this.props.activeJumperIdsOnLoad){
			jumperOptions = jumperOptions.filter(
				option =>
					this.props.activeJumperIdsOnLoad.findIndex(
						id => option.value._id === id
					) === -1
			);
		}
		//this.setState({jumperOptions: jumperOptions});
		this.setFuse(jumperOptions);
	}

	componentWillMount = () => {
		//console.og('CreateJump componentWillMount');
		// this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func));
		// this.timerId = setTimeout(this.cancelOrSubmit, 5000) // call the `toggle` function after 5000ms
	}

	setFuse = (jumperOptions) => {
		var options = {
			shouldSort: true,
			tokenize: false,
			threshold: 0.1,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: [
				"label",
				"value.manifestNumber"
			]
		};

		this.fuse = new Fuse(jumperOptions, options); // "list" is the item array
	}

	Option = (props) => {

		var studentgearModel = ".gear1" + props.data.value._id;
		var studentname = "gear1" + props.data.value._id;

		var sportgearModel = ".gear2" + props.data.value._id;
		var sportname = "gear2" + props.data.value._id;

		return (
			<div className="row">
				<div className="col-5">
					<components.Option {...props} />
				</div>

				<div className="col-7" style={{ paddingTop: '6px' }}>
					<div className="row">
						student gear <Control.checkbox model={studentgearModel} name={studentname} onChange={value => { this.updateGear(value) }} />
					</div>
					<div className="row" style={{ paddingTop: '6px' }}>
						sport gear rent <Control.checkbox model={sportgearModel} name={sportname} onChange={value => { this.updateGear(value) }} />
					</div>
				</div>


			</div>
		);
	}

	MultiValueLabel = (props) => {
		// console.log(props);
		// console.log(props.data);

		return (
			<div className="row">
				<div className="col-12"><components.MultiValueLabel {...props} /></div>
				{this.studentgearIds.indexOf(props.data.value._id) > -1 || this.sportgearIds.indexOf(props.data.value._id) > -1 ? <div className="col-12">-G</div> : null}
			</div>
		);
	}

	toggleModal() {
		this.setState({
			isModalOpen: !this.state.isModalOpen,
			jumpType: null
		});

		this.gearIds.length = 0;
	}

	updateGear(value) {
		//console.og(value);
		//console.og(value.target);


		// console.log(value);
		// console.log(value.target);

		var id = value.target.name.substr(5);
		var type = value.target.name.substr(0, 5);
		//alert('gear click ' + value.target.checked);

		if (type === "gear1") {
			if (value.target.checked) {
				this.studentgearIds.push(id);
			}
			else {
				this.studentgearIds = this.studentgearIds.filter(gearId => gearId !== id);
			}
		}
		else if (type === "gear2") {
			if (value.target.checked) {
				this.sportgearIds.push(id);
			}
			else {
				this.sportgearIds = this.sportgearIds.filter(gearId => gearId !== id);
			}
		}
		clearTimeout(this.timerId);
		this.timerId = setTimeout(this.cancelOrSubmit, 5000);
	}

	/*
	handleSubmit(values, loadNum, jumpId){

			if (values.jumpers != undefined && values.jumpers.length>0) {
					//this.toggleModal();

					var jumpPostBody = {
							jumperIds: values.jumpers.map(jumperOption => jumperOption.value._id)
					};

					jumpPostBody.gearRentals = this.gearIds.filter(id => jumpPostBody.jumperIds.indexOf(id)>=0 );

					//console.og(jumpPostBody);
					loadsStore.addJumpers(loadNum, jumpId, jumpPostBody);
			}
			else {
					this.setState({
							isloading: false,
							ErrorMessage: 'Invalid Input !',
							isValid: false
					})
			}

			setTimeout(() => {
					this.setState({ isValid: true });
			}, 2000);
	} */
	updateJumperOptions = () => {
		console.log('in add jumper update Jumper Options');
		if(this.props.type === "observer"){
			var jumperOptions = jumpersStore.getTandemStudentOptions();
			if(this.props.activeJumperIdsOnLoad){
				jumperOptions = jumperOptions.filter(
					option =>
						this.props.activeJumperIdsOnLoad.findIndex(
							id => option.value._id === id
						) === -1
				);
			}
		}
		else{
			var jumperOptions = jumpersStore.getJumperOptions().filter(opt => opt.value.isTeam !==true);
			if(this.props.activeJumperIdsOnLoad){
				jumperOptions = jumperOptions.filter(
					option =>
						this.props.activeJumperIdsOnLoad.findIndex(
							id => option.value._id === id
						) === -1
				);
			}
		}

		this.setState({jumperOptions: jumperOptions});
		this.setFuse(jumperOptions);
	}
	addHoldJumper = (loadNum, jumpId) => {
		//alert('edit Mode');
		//loadsStore.addEditableJumper(load, loadNum, jumpId);

		// let jumperDetails = localStorage.getItem("jumperDetails")
		let jumperDetails = localStorage.getItem("jumperD")
		// let jumpers = this.props.jumperOptions.filter(val => val.value._id == jumperDetails._id)

		if (jumperDetails) {
			let jumperDetailsStringify = JSON.parse(jumperDetails)
			// jumpers[0].label
			var jumpPostBody = {
				jumperIds: [jumperDetailsStringify._id]
			};
			jumpPostBody.gearRentals = this.gearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			//console.og(jumpPostBody);

			jumpPostBody.pending = false
			loadsStore.addJumpers(this.props.loadNum, this.props.jumpId, jumpPostBody);
		} else {

			if (ReactDOM.findDOMNode(this).getBoundingClientRect().y > window.innerHeight / 2) {
				this.setState({ placement: "top" });
			}
			else {
				this.setState({ placement: "bottom" });
			}
			//console.og('in addHoldJumper');
			this.updateJumperOptions();
			this.setState({ editMode: true });
		}


		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000) // call the `toggle` function after 5000ms
		//clearTimeout(this.timerId);

	}

	filterJumpers = (inputValue, jumperOptions) => {
		//console.og("in filterJumpers");
		if (inputValue) {
			//console.og(inputValue);
			/*var filteredOptions = jumperOptions.filter(i =>
							i.label.toLowerCase().includes(inputValue.toLowerCase()));*/
			var filteredOptions = this.fuse.search(inputValue.toLowerCase());

			//console.og(filteredOptions);
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
		return jumperOptions;
	};

	promiseOptions = (inputValue, jumperOptions) => {
		//console.og('in pomiseOptions');
		//console.og(this.state.inputValue);
		return new Promise(resolve => {
			resolve(this.filterJumpers(this.inputValue, jumperOptions));
		});
	};

	cancelOrSubmit = () => {

		//alert(JSON.stringify('cancel or submit'));
		if (this.state.jumpers.length > 0) {
			var jumpPostBody = {
				jumperIds: this.state.jumpers.map(jumperOption => jumperOption.value._id)
			};
			jumpPostBody.gearRentals = this.gearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			jumpPostBody.studentgearRentals = this.studentgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			jumpPostBody.sportgearRentals = this.sportgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			//console.og(jumpPostBody);
			loadsStore.addJumpers(this.state.loadNum, this.state.jumpId, jumpPostBody);
		}
		else {
			this.setState({
				isloading: false,
				ErrorMessage: 'Invalid Input !',
				isValid: false
			})
		}
		this.setState({ editMode: false, jumpers: [] });
	}

	handleChange = (value, jumpId, loadId) => {
		//alert("in handleChange" + JSON.stringify(value));
		if (value.length > 0) {
			var jumpPostBody = {
				jumperIds: value.map(jumperOption => jumperOption.value._id)
			};
			jumpPostBody.studentgearRentals = this.studentgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			jumpPostBody.sportgearRentals = this.sportgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);

			//console.og(jumpPostBody);
			loadsStore.addJumpers(loadId, jumpId, jumpPostBody);
		}
		else {
			this.setState({
				isloading: false,
				ErrorMessage: 'Invalid Input !',
				isValid: false
			})
		}
		this.setState({ editMode: false, jumpers: [] });
		/*
		this.valRef.focus();
		this.setState({jumpers:value})
		clearTimeout(this.timerId);
		this.timerId = setTimeout(this.cancelOrSubmit, 5000);*/
	}

	handleInputChange = (newValue) => {
		//console.og('handleInputChange');
		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
		//const inputValue = newValue.replace(/\W/g, '');
		////console.og(inputValue);

		//console.og(newValue);
		//this.promiseOptions(newValue, jumperOptions);
		this.inputValue = newValue;
		this.valRef.focus();
		////alert('in handleInputChange');
		//return inputValue;
	};

	handleSubmit = (newValue) => {
		////alert('in blur');
		alert('handle submit');
		//console.og('in blur: ');
		//console.og(newValue);
		//this.setState({editMode:false});
		//return inputValue;
	};

	onBlur = () => {
		//alert('onBlur');
		this.setState({ editMode: false });
	}

	render() {

		var newbtnStyle = {
			padding: 0
		}
		let jumperName = 'jumper-name'
		if (this.props.loadsToShow > 3) {
			jumperName = 'jumper-name overwriteposition'
		}
		return (
			<React.Fragment>
				{
					!this.state.editMode ?
						<ul className="plusBtn" >
							<button className={`btn ${jumperName}`}
								onClick={() => this.addHoldJumper(this.props.loadNum, this.props.jumpId)}
								type="submit"
								disabled={this.props.disabled}
							>
								<i className="fa fa-plus"></i>
							</button>
						</ul>
						:
						// <button className="btn lightBlueButton jumper-name" disabled={this.props.disabled}>
						<button disabled={this.props.disabled} style={newbtnStyle}>

							<LocalForm form="addjumpers" model="addjumpers" getDispatch={dispatch => this.formDispatch = dispatch} style={{ width: '270px' }}>
								<AsyncSelect model=".jumper" name="jumper" ref={(value) => this.valRef = value} loadOptions={(newValue) => this.promiseOptions(newValue, this.state.jumperOptions)}
									ref={(value) => this.valRef = value}
									defaultOptions={this.state.jumperOptions.slice(0, 10)}
									//onChange={this.handleChange}
									onChange={(value) => this.handleChange(value, this.props.jumpId, this.props.loadNum)}
									isMulti
									onInputChange={(newValue) => this.handleInputChange(newValue)}
									components={{ Option: this.Option, MultiValueLabel: this.MultiValueLabel }}
									menuPortalTarget={document.body}
									menuPosition="absolute"
									menuPlacement={this.state.placement}
									onBlur={this.onBlur}
								/>
							</LocalForm>
						</button>

				}
			</React.Fragment>
		);
	}
}

export default AddJumpers
